export const it = {
    words: {
        'day': 'giorno',
        'days': 'giorni',
    },
    general: {
        cancel: 'Cancella',
    },
    calendar: {
        days: {
            sun: 'Dom',
            mon: 'Lun',
            tue: 'Mar',
            wed: 'Mer',
            thu: 'Gio',
            fri: 'Ven',
            sat: 'Sab'
        },
        months: {
            jan: 'Gennaio',
            feb: 'Febbraio',
            mar: 'Marzo',
            apr: 'Aprile',
            may: 'Maggio',
            jun: 'Giugno',
            jul: 'Luglio',
            aug: 'Agosto',
            sep: 'Settembre',
            oct: 'Ottobre',
            nov: 'Novembre',
            dec: 'Dicembre'
        },
        short_months: {
            jan: 'Gen',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Apr',
            may: 'Mag',
            jun: 'Giu',
            jul: 'Lug',
            aug: 'Ago',
            sep: 'Set',
            oct: 'Ott',
            nov: 'Nov',
            dec: 'Dic'
        },
        today: 'Oggi',
        tomorrow: 'Domani',
        yesterday: 'Ieri',
        week: 'Settimana',
        month: 'Mese',
        year: 'Anno'
    },
    cities: {
        browse: 'Ricerca per destinazione',
        bologna: 'Bologna',
        firenze: 'Firenze',
        cagliari: 'Cagliari',
        bari: 'Bari',
        milano: 'Milano',
        roma: 'Roma',
        palermo: 'Palermo',
        catania: 'Catania',
        links: {
            bologna: 'https://scopri.auting.it/car-sharing-tra-privati-bologna/',
            firenze: 'https://scopri.auting.it/car-sharing-tra-privati-firenze/',
            cagliari: 'https://scopri.auting.it/car-sharing-tra-privati-cagliari/',
            bari: 'https://scopri.auting.it/car-sharing-tra-privati-bari/',
            milano: 'https://scopri.auting.it/car-sharing-tra-privati-milano/',
            roma: 'https://scopri.auting.it/car-sharing-tra-privati-roma/',
            palermo: 'https://scopri.auting.it/car-sharing-tra-privati-palermo/',
            catania: 'https://scopri.auting.it/car-sharing-tra-privati-catania/',
        }
    },
    components: {
        search_bar: {
            cta: 'Cerca',
            select_date: 'Seleziona data',
            select_dates: 'Seleziona date',
            time: 'Orario',
            time_label: 'Orario',
            select_start_datetime: 'Seleziona data e ora di inizio',
            select_end_datetime: 'Seleziona data e ora di fine',
            booking_warning: 'Le prenotazioni devono iniziare almeno 2 ore dopo l\'orario corrente',
            cancel: 'Annulla',
            confirm: 'Conferma',
            confirm_dates: 'Conferma Date',
            start_date: 'Data inizio',
            end_date: 'Data fine',
            start_time_label: 'Orario inizio',
            end_time_label: 'Orario fine',
            end_before_start_error: 'La data di fine non può essere precedente alla data di inizio!',
            coordinates_error: 'Errore nel recupero delle coordinate. Riprova con un altro indirizzo.'
        },
        nav: {
            how_it_works: 'Come funziona',
            faq: 'FAQ',
            publish_your_car: 'Pubblica la tua auto',
            sign_in: 'Accedi',
            get_started: 'Registrati',
            profile: 'Profilo',
            earnings: 'I tuoi guadagni',
            cars: 'Le tue auto',
            trips_driver: 'I tuoi viaggi',
            trips_owner: 'I viaggi con le tue auto',
            documents: 'Documenti',
            change_language: 'Cambia lingua',
            menu: 'Menu',
            open_menu: 'Apri menu',
            logout: 'Logout',
            push_notifications: 'Notifiche push',
            push_denied_hint: 'Notifiche bloccate: abilitale dalle impostazioni del browser.',
            push_error: 'Impossibile aggiornare le notifiche. Riprova.',
            push_open: 'Apri',
        },
        footer: {
            branding_section: {
                claim: 'Conveniente come l\'auto del tuo vicino',
                description: 'Auting è la prima piattaforma italiana di car sharing peer-to-peer. Il servizio ti consente di prenotare un\'auto da un Owner privato per uno o più giorni consecutivi. Viaggia ovunque in Italia, con la tranquillità di un forte partner assicurativo come Reale Mutua.',
            },
            links_section: {
                learn_more: 'Scopri di più',
                how_it_works: 'Come funziona',
                publish_your_car: 'Pubblica la tua auto',
                faq: 'FAQ',
                blog: 'Blog',
                product: 'Prodotto',
                download_ios: 'Scarica su iOS',
                download_android: 'Scarica su Android',
                legal: 'Legale',
                limitations: 'Limitazioni',
                privacy_policy: 'Informativa sulla privacy',
                terms_of_service: 'Termini di servizio',
                cookie_policy: 'Informativa sui cookie',
                copyright: '© Yago s.r.l. 2018 - all rights reserved - P. IVA 03488191200',
                support_email: 'support@auting.it',
                partner: 'Partner',
            }
        },
        faq: {
            title_first_line: 'Le tue domande,',
            title_second_line: 'le nostre risposte',
            cta: 'Leggi tutte le FAQ',
            owner: {
                accordions: {
                    '1': {
                        question: 'Come faccio a condividere la mia auto?',
                        answer: 'La pubblicazione di un\'auto è molto rapida. Puoi farla:\n\n - sul sito web di Auting facendo clic sul pulsante "Pubblica la tua auto" nell\'angolo in alto a destra della home page;\n - Tramite l\'App Auting, disponibile negli store Android e iOS, facendo clic sull\'icona dell\'auto nella home page dell\'App.',
                    },
                    '2': {
                        question: 'Come funziona il ritiro e la riconsegna dell\'auto?',
                        answer: 'Il ritiro dell\'auto avviene solo dopo che la prenotazione è stata pagata. Dopo il pagamento, il numero di telefono del Proprietario sarà visibile nei dettagli del viaggio. I luoghi di ritiro e riconsegna dell\'auto possono essere concordati tra il Conducente e l\'Owner durante il processo di prenotazione.',
                    },
                    '3': {
                        question: 'Chi stabilisce il prezzo della mia auto?',
                        answer: 'Sei libero di impostare il prezzo minimo desiderato per la tua auto e di aggiornarlo in qualsiasi momento. Puoi anche impostare un prezzo per i chilometri aggiuntivi che possono essere acquistati dal Conducente durante il processo di prenotazione.'
                    },
                    '4': {
                        question: 'Chi paga per il rifornimento dell\'auto?',
                        answer: 'Ti suggeriamo di consegnare l\'auto con il pieno di carburante. Il Conducente è responsabile di restituire l\'auto con lo stesso livello di carburante presente al momento del ritiro e contrassegnato nella Checklist.',
                    },
                    '5': {
                        question: 'Quanti chilometri può percorrere il Conducente?',
                        answer: 'Per ogni giorno di prenotazione, il Conducente ha a disposizione 150 km con un massimo di 500 km a settimana. Al momento della prenotazione, il Conducente può acquistare chilometri aggiuntivi. Il prezzo dei chilometri aggiuntivi è stabilito dal Proprietario nella sezione prezzi del profilo dell\'auto.'
                    },
                },
            },
            driver: {
                accordions: {
                    '1': {
                        question: 'Come faccio a prenotare un\'auto?',
                        answer: 'Puoi trovare un\'auto sia dalla homepage di questo sito web che dall\'app di Auting digitando la città e le date che stai cercando.\nVedrai le auto disponibili nella città e nelle date scelte su una mappa e in un elenco con prezzo e modello dell\'auto.\nSarai in grado di inviare più richieste di prenotazione contemporaneamente.\nI Proprietari potranno accettare la tua richiesta, rifiutarla o lasciarla scadere.\nUna volta che la tua richiesta è stata accettata, puoi procedere con il pagamento',
                    },
                    '2': {
                        question: 'Ci sono requisiti per i conducenti per prenotare un\'auto?',
                        answer: 'Al momento della richiesta di prenotazione, il Conducente deve avere almeno 21 anni e deve possedere una patente di guida valida in Italia da almeno 3 anni.\nIl Conducente deve possedere i seguenti documenti:\n\n - un documento di identità valido (carta d\'identità o passaporto)\n\n - una patente di guida valida in Italia (la data di prima emissione o l\'ultimo rinnovo della patente deve essere presente sul documento e deve essere datata prima degli ultimi 3 anni). - se la patente è stata rilasciata in un paese al di fuori dell\'Unione Europea, il Conducente deve presentare, oltre alla patente nazionale, un Permesso di Guida Internazionale (IDP)',
                    },
                    '3': {
                        question: 'Sono assicurato contro tutti i rischi?',
                        answer: 'Per tutta la durata della prenotazione, l\'auto è coperta da Reale Mutua Assicurazioni contro danni, furto, rottura cristalli e atti vandalici, con assistenza stradale premium 24 ore su 24, 7 giorni su 7  e cauzione pari a 0 €.\n\n Al momento della prenotazione è possibile scegliere il livello di esposizione al rischio di danni o furto e arrivare fino a 0 € di responsabilità.\n\nLa tariffa base include già una limitazione di responsabilità bassa.'
                    },
                    '4': {
                        question: 'Come funziona il ritiro e la riconsegna dell\'auto?',
                        answer: 'Il ritiro dell\'auto avviene solo dopo che la prenotazione è stata pagata.\nDopo il pagamento, il numero di telefono del Proprietario sarà visibile nei dettagli del viaggio.\nI luoghi di ritiro e riconsegna dell\'auto possono essere concordati tra il Conducente e l\'Owner durante il processo di prenotazione.',
                    },
                    '5': {
                        question: 'Qual è la differenza tra Auting e le compagnie di noleggio?',
                        answer: 'Auting è un servizio ecologico che consente l\'utilizzo di auto che altrimenti rimarrebbero inutilizzate.\nQuesto rende possibile fornire un servizio più user-friendly, basato su una connessione diretta con l\'Owner.\nInfine, il prezzo di Auting è più economico rispetto a un servizio di noleggio auto e include:\n\n - assistenza stradale premium 24/7\n - deposito cauzionale di 0 €\n - una soglia di responsabilità limitata (da selezionare al momento della prenotazione).'
                    },
                },
            }
        },
        blog: {
            title: 'Auting Blog',
            cta: 'Leggi di più'
        },
        owner: {
            top_subheadline: 'Hai un\'auto?',
            headline: 'Falla guadagnare',
            cta: 'Pubblica la tua auto',
            img_alt: 'Illustrazione Proprietario',
        },
        mobile_app: {
            subtitle: 'Usa Auting sul tuo telefono',
            title: 'Inizia il tuo viaggio',
            title_accent: 'con un semplice tocco 🎯',
        }
    },
    common: {
        back: 'Indietro',
        any: 'Qualsiasi',
        reset: 'Reset',
        apply: 'Applica',
        retry: 'Riprova',
        yes: 'Sì',
        no: 'No',
        per_day: 'giorno'
    },
    errors: {
        generic: 'Si è verificato un errore. Riprova più tardi.',
        reservation: {
            Numero_telefono_mancante_o_non_verificato_prenotazione_veicolo_non_consentita: 'Non puoi effettuare una prenotazione perché non hai ancora verificato il tuo numero di telefono. Vai al tuo profilo per verificare il numero di telefono.',
            Prenotazione_veicolo_non_consentita_Specificare_nome_e_cognome: 'Non puoi effettuare una prenotazione perché il tuo profilo non contiene il tuo nome e cognome completi. Vai al tuo profilo per aggiungere queste informazioni.',
            Data_inizio_prenotazione_mancante: 'Per prenotare un veicolo è necessario specificare una data di inizio valida per la prenotazione.',
            Data_fine_prenotazione_mancante: 'Per prenotare un veicolo è necessario specificare una data di fine valida per la prenotazione.',
            Data_in_formato_non_corretto: 'La data fornita non è nel formato corretto. Utilizzare il formato AAAA-MM-GG HH:MM.',
            Id_del_veicolo_mancante: 'Per prenotare un veicolo è necessario selezionare un veicolo valido.',
            Messaggio_di_richiesta_prenotazione_mancante: 'Per prenotare un veicolo è necessario fornire un messaggio di richiesta di prenotazione all\'Owner.',
            Lunghezza_del_messaggio_superiore_al_limite_consentito: 'La lunghezza del messaggio di richiesta di prenotazione supera il limite consentito di 500 caratteri.',
            Data_di_inizio_noleggio_successiva_alla_data_di_fine_noleggio: 'La data di inizio del viaggio non può essere successiva alla data di fine.',
            La_data_di_inizio_noleggio_non_può_coincidere_con_la_data_di_fine_noleggio: 'La data di inizio del viaggio non può coincidere con la data di fine del viaggio.',
            Periodo_della_prenotazione_superiore_al_massimo_consentito: 'Il periodo di prenotazione supera il limite massimo consentito di 30 giorni.',
            Prenotazione_non_consentita_data_di_inizio_viaggio_troppo_ravvicinata: 'La prenotazione non è consentita: la data di inizio del viaggio è troppo ravvicinata. La prenotazione deve iniziare almeno 2 ore dopo l\'orario corrente.',
            Veicolo_gia_prenotato_per_il_periodo_indicato: 'Il veicolo è già prenotato per il periodo indicato.',
            Prezzo_veicolo_non_ancora_impostato_prenotazione_veicolo_non_consentita: 'Il veicolo non può essere prenotato per ché il prezzo non è ancora stato impostato dall\'Owner.',
            Prezzo_veicolo_non_ancora_impostato_pubblicazione_veicolo_non_consentita: 'Il veicolo non può essere pubblicato perché il prezzo non è ancora stato impostato dall\'Owner.',
            Prenotazione_non_consentita_lutente_che_richiede_la_prenotazione_è_il_proprietario_del_veicolo: 'Non puoi prenotare il tuo veicolo.',
            Veicolo_non_trovato: 'Il veicolo selezionato non esiste.',
            Veicolo_di_annata_superiore_al_limite_consentito_non_prenotabile: 'Il veicolo selezionato è di annata superiore al limite consentito e non può essere prenotato.',
            Prezzo_della_prenotazione_fuori_range: 'Il prezzo della prenotazione è fuori dall\'intervallo consentito.'
        }
    },
    routes: {
        login: {
            title: 'Accedi al tuo account',
            subtitle: 'Inserisci le tue credenziali per continuare.',
            else: 'altro',
            dont_have_account: 'Non hai un account?',
            register: 'Registrati',
            enter_email: 'Inserisci la tua email',
            enter_password: 'Inserisci la tua password',
            forgot_password: 'Hai dimenticato la password?',
            logging_in: 'Accesso in corso',
            login: 'Accedi',
        },
        register: {
            title: 'Registrati per Auting',
            subtitle: 'Compila il modulo per creare il tuo account.',
            first_name: 'Nome',
            your_first_name: 'Il tuo nome',
            last_name: 'Cognome',
            your_last_name: 'Il tuo cognome',
            else: 'altro',
            do_have_an_account: 'Hai già un account?',
            login: 'Accedi',
            register: 'Registrati',
            registering: 'Registrazione in corso',
            enter_email: 'Inserisci la tua email',
            enter_password: 'Crea una password',
            forgot_password: 'Hai dimenticato la password?',
            success_message_in_dialog: 'Registrazione avvenuta con successo! Controlla la tua email per confermare il tuo account, poi accedi.',
        },
        forgot_password: {
            title: 'Reset Password',
            description: 'Recupera la tua password Auting',
            header_title: 'Recupera Password',
            header_subtitle: 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
            email_placeholder: 'Inserisci la tua email',
            enter_email: 'Inserisci la tua email',
            invalid_email: 'Inserisci un\'email valida',
            reset_error: 'Errore durante l\'invio dell\'email di reset',
            sending: 'Invio...',
            send_reset_link: 'Invia Link di Reset',
            back_to_login: '← Torna al Login',
            email_sent: 'Email Inviata!',
            email_sent_message: 'Abbiamo inviato un link per il reset della password a <strong>{email}</strong>, controlla la tua email e segui le istruzioni per reimpostare la password.',
            go_to_login: 'Vai al Login',
        },
        home: {
            title: 'Auting: il car sharing tra privati in Italia',
            description: 'Scegli l\'auto perfetta per te, prenotala e parti. Migliaia di auto di privati ti aspettano in tutta Italia. Dimentica il noleggio auto, dimentica il car sharing, scopri il car sharing tra privati di Auting!',
            keywords: 'car sharing, peer-to-peer car sharing, noleggio auto, affitto auto, Auting',
            header: {
                title: "Trova, prenota, parti",
                description: "Prenota un'auto da un privato in 150 città in tutta Italia",
                project_insured_by: "Progetto assicurato da",
            },
            search: {
                placeholder: "Cerca l'auto perfetta",
                button: "Cerca",
            },
            steps_title: 'Un\'auto per le vacanze, per il lavoro, per traslocare... basta seguire questi pochi passaggi:',
            steps: {
                '1': 'Trova l\'auto perfetta per te',
                '2': 'Chatta con l\'Owner',
                '3': 'Paga la prenotazione',
                '4': 'Recupera l\'auto e parti',
            },
            pricing: {
                subtitle: 'Cerchi qualcosa di meglio di un servizio di noleggio auto?',
                title_accent: 'Sicura, Conveniente, Comoda.',
                description: 'L\'auto dei nostri Owner è facile da raggiungere e ti offre viaggi comodi e tranquilli.',
                cols: {
                    auting: {
                        description: 'I prezzi di base includono già opzioni PREMIUM:',
                        items: {
                            '1': '✅ 0€ deposito cauzionale',
                            '2': '✅ Bassa responsabilità in caso di danni o furto',
                            '3': '✅ Assistenza stradale premium 24/7',
                            '4': '✅ Comunicazione e ritiro facili',
                        },
                        alt: {
                            sub_description: 'Inoltre:',
                            sub_items: {
                                '1': '✅ Con soli 6 €/gg hai 0€ responsabilità in caso di danni o furto'
                            }
                        }
                    },
                    other: {
                        title: 'Altri servizi',
                        description: 'I prezzi iniziali nascondono:',
                        items: {
                            '1': '❌ 1500 - 3500 € deposito cauzionale',
                            '2': '❌ Alta responsabilità fino a 3500 €',
                            '3': '❌ Assistenza base',
                            '4': '❌ Lunghe code al banco',
                        },
                        alt: {
                            sub_separator: 'oppure:',
                            sub_description: '❌ fino a 50€/gg in aggiunta al prezzo base del noleggio per:',
                            sub_items: {
                                '1': '- 0€ di responsabilità danni/furto',
                                '2': '- deposito cauzionale 0€',
                                '3': '- assicurazione premium'
                            }
                        }
                    }
                }
            },
            auting_values: {
                title: 'e molto altro:',
                cols: {
                    '1': {
                        headline: 'Un\'auto alla portata di tutti',
                        text: 'Auto situate all\'interno della città, vicino a stazioni ferroviarie e aeroporti. O proprio dietro l\'angolo!',
                    },
                    '2': {
                        headline: 'Non solo un servizio, una vera comunità',
                        text: '+65.000 utenti attivi tra Owner e Driver',
                    }
                },
                cta: 'Scopri di più',
            },
            cities: {
                cta: 'Cerca un\'auto in 150 città',
            },
            cars_grid: {
                title: "Le migliori auto a Milano",
                loading: 'Caricamento delle auto...',
                no_vehicles: 'Nessuna auto trovata per questa ricerca',
                error: 'Errore nel caricamento: ',
            }
        },
        driver: {
            title: 'Auting: come funziona?',
            description: 'Scopri come funziona il car sharing tra privati di Auting. Scopri le auto dgli Owner privati intorno a te, invia una richiesta e viaggia ovunque in Italia da 1 giorno fino a 30 giorni consecutivi. Facile quanto conveniente.',
            header: {
                title: 'Come funziona Auting?',
            },
            how_it_works: {
                title: '',
                cols: {
                    '1': {
                        headline: 'Trova l\'auto perfetta per te',
                        subheadline: 'Inserisci dove e quando hai bisogno di un\'auto, visualizza l\'offerta e leggi le recensioni degli utenti precedenti.',
                    },
                    '2': {
                        headline: 'Chatta con l\'Owner',
                        subheadline: 'Invia richieste ai Proprietari e chatta direttamente con loro per organizzare il ritiro dell\'auto.',
                    },
                    '3': {
                        headline: 'Paga la prenotazione',
                        subheadline: 'Pagamento sicuro con carta di credito tramite la piattaforma.',
                    },
                    '4': {
                        headline: 'Ritira l\'auto e parti!',
                        subheadline: 'Il giorno della prenotazione incontra l\'Owner per la consegna o sblocca il veicolo con l\'app.',
                    }
                }
            },
            advantages: {
                title: 'Perché i prezzi di Auting sono così convenienti?',
                cols: {
                    '1': {
                        items: {
                            '1': 'Responsabilità limitata per danni o furto',
                            '2': 'Copertura assicurativa premium',
                            '3': 'Assistenza stradale premium 24/7',
                            '4': 'Cancellazione gratuita',
                            '5': 'Deposito cauzionale 0€',
                            '6': 'Comunicazione facile per il ritiro',
                            '7': 'E IN PIÙ',
                            '8': '<strong>PROMO:</strong> con soli 6 €/gg hai 0€ responsabilità in caso di danni o furto'
                        }
                    },
                    '2': {
                        title: 'Prezzi di un classico noleggio auto',
                        items: {
                            '1': 'Responsabilità fino a 3500€',
                            '2': 'Nessuna assistenza stradale premium',
                            '3': '1500-3500 euro di deposito cauzionale',
                            '4': 'La cancellazione non è sempre inclusa o può comportare una penale finanziaria',
                            '5': 'Fino a 50€/gg in aggiunta al prezzo base del noleggio per:\n\n - 0€ di responsabilità danni/furto\n\n - deposito cauzionale 0€\n\n - assicurazione premium',
                            '6': 'Lunga attesa',
                        }
                    },
                }
            },
            service: {
                title: 'Un servizio intelligente e conveniente',
                cols: {
                    '1': {
                        headline: 'Un servizio di prossimità',
                        subheadline: 'Le auto si trovano intorno a te. Geolocalizzati e raggiungi l\'auto più vicina per partire verso la tua destinazione.',
                    },
                    '2': {
                        '1': {
                            headline: 'Check-in veloce!',
                            subheadline: 'Dimentica le code al banco di noleggio per ritirare la tua auto. Ritira la tua auto in soli 5 minuti!',
                        },
                        '2': {
                            headline: 'Un servizio capillare',
                            subheadline: 'Le auto di Auting sono ovunque in Italia, nelle strade dei centri città, vicino a stazioni o aeroporti.',
                        },
                    }
                }
            }
        },
        owner: {
            title: 'Auting: condividi la tua auto',
            description: 'Diventa Owner Auting e guadagna condividendo la tua auto. Registra la tua auto gratuitamente in pochi semplici passi. Condividila quando vuoi, al prezzo che vuoi.',
            earn: {
                title: 'La tua auto potrebbe guadagnare {currency} {earnings}',
                slider: '{days} {unit}',
                estimated_earnings: 'La tua stima di guadagno per {days} giorni di condivisione al mese',
                loading: 'Caricamento dei tuoi potenziali guadagni...',
                loading_car_data: 'Ottenimento dei dati più recenti dell\'auto...',
                loading_error: 'Errore nel caricamento dei dati',
                cta: 'Pubblica la tua auto',
                img_alt: 'Illustrazione dell\'auto che guadagna',
                select_car_type: 'Seleziona tipo auto',
                select_car_year: 'Seleziona anno auto'
            },
            metrics: {
                title: 'Unisciti a migliaia dgli Owner su Auting.',
                title_accent: 'È facile e sicuro.',
                cols: {
                    '1': {
                        headline: '+8.000',
                        subheadline: 'auto registrate',
                    },
                    '2': {
                        headline: '+65.000',
                        subheadline: 'utenti',
                    },
                    '3': {
                        headline: '24/7',
                        subheadline: 'Assistenza premium',
                    },
                    '4': {
                        headline: 'Coperto da',
                        subheadline: '',
                        image: true,
                    }
                }
            },
            how_to_publish: {
                title: 'Pubblica la tua auto.<br/>Condividi. Guadagna.',
                title_accent: 'Sembra facile? Lo è.',
                cols: {
                    '1': {
                        headline: 'Registrati',
                        subheadline: 'Crea il tuo account e pubblica la tua auto.',
                    },
                    '2': {
                        headline: 'Pubblica',
                        subheadline: 'Carica foto e una descrizione dell\'auto. Specifica il prezzo e la disponibilità.',
                    },
                    '3': {
                        headline: 'Condividi',
                        subheadline: 'Ricevi le richieste, accettale o rifiutale. Contatta direttamente il Driver!',
                    },
                    '4': {
                        headline: 'Guadagna',
                        subheadline: 'Ricevi i guadagni direttamente sul tuo conto alla fine del viaggio.',
                    }
                }
            },
            advantages: {
                title: 'Perché Auting',
                title_accent: 'è così unico?',
                cols: {
                    '1': {
                        headline: 'Auting è un servizio collaudato e sicuro',
                        subheadline: 'Supportato da partner fidati come Cassa Depositi Prestiti e Reale Mutua Assicurazioni.',
                    },
                    '2': {
                        headline: 'Proteggere la tua auto è tutto per noi',
                        subheadline: 'L\'assicurazione e l\'assistenza stradale premium 24/7 sono sempre inclusi nel servizio.',
                    },
                    '3': {
                        headline: 'Ti supportiamo nella condivisione',
                        subheadline: 'Il servizio clienti, l\'intermediazione con i conducenti e la verifica degli utenti sono inclusi nel servizio.',
                    },
                    '4': {
                        headline: 'Contribuiamo al tuo successo',
                        subheadline: 'Il nostro sito web e la nostra app lavorano per rendere la tua auto più visibile, sia ai tuoi vicini che ai viaggiatori italiani o stranieri.',
                    },
                    '5': {
                        headline: 'Transazioni facili e sicure',
                        subheadline: 'Raccogliamo il denaro dal conducente prima del viaggio. Al termine del viaggio ricevi da noi un bonifico direttamente sul tuo conto.',
                    }
                }
            },
            ways_of_sharing: {
                title_first_line: '2 modi',
                title_second_line: 'di condividere la tua auto',
                cols: {
                    '1': {
                        headline: 'Incontro con l\'Owner',
                        subheadline: 'Incontra l\'Owner presso il luogo stabilito. Compila la checklist e fotografa lo stato dell\'auto. Scambia le chiavi.',
                    },
                    '2': {
                        headline: 'Auting Connect',
                        subheadline: 'Disponibile solo nella città di Milano. Con il dispositivo Auting Connect puoi condividere l\'auto da remoto tramite l\'App',
                        label_accent: 'Guadagna di più!',
                    },
                },
            },
            protections: {
                top_subheadline_accent: '“È sicuro? Riguarda la mia auto!”',
                title: 'Proteggere la tua auto è la nostra prima priorità',
                cta: 'Scopri di più',
                insured_by: 'Progetto assicurato da',
                cols: {
                    1: {
                        top_subheadline_accent: 'No worries',
                        headline: 'Sei protetto ✅',
                    },
                    2: {
                        headline: 'Assistenza stradale premium 24/7',
                        subheadline: 'Servizio di traino del veicolo fino all\'officina più vicina o prescelta.',
                    },
                }
            },
            super_owner: {
                title: 'Più condividi, più guadagni',
                text: 'Scopri il programma SuperOwner.',
                cta: 'Scopri di più',
            },

        },
        car: {
            instant_booking: 'Accettazione istantanea',
            instant_booking_hint: 'Questo veicolo accetta le richieste automaticamente: ricevi subito la conferma.',
            page_title: 'Noleggio auto',
            car: 'Auto',
            owner: 'Proprietario',
            new: 'Nuovo',
            not_specified: 'Non specificato',
            location_not_available: 'Posizione non disponibile',
            discount_example: 'Sconto 3 giorni, 7€',
            free_cancellation_until: 'Cancellazione gratuita fino a',
            hours_before: 'ore prima',
            free_cancellation_24h: 'Cancellazione gratuita fino a 24h prima',
            km_included: 'km inclusi',
            rca_base_included: 'RCA Base inclusa',
            not_included: 'Non incluso',
            to_be_chosen: 'Da scegliere',
            vehicle_not_available: 'Veicolo non disponibile per le date selezionate',
            please_select_dates: 'Seleziona le date di prenotazione',
            vehicle_info_missing: 'Le informazioni del veicolo sono mancanti',
            seats: 'posti',
            doors: 'porte',
            trips: 'viaggi',
            insurance: 'Assicurazione',
            comforts: 'Comfort',
            no_comforts_listed: 'Nessun comfort specifico elencato',
            conditions: 'Condizioni di prenotazione',
            vehicle_details: 'Dettagli veicolo',
            keyless: 'Apertura senza chiavi',
            verified: 'Verificato',
            mileage: 'Chilometraggio',
            loading_owner_info: 'Caricamento info Owner...',
            failed_load_owner_info: 'Impossibile caricare info Owner',
            trips_as_owner: 'viaggi come Owner',
            super_owner: 'Super Owner',
            pro: 'Professionale',
            about_vehicle: 'Informazioni su questo veicolo',
            about_vehicle_description: '',
            how_does_it_work: 'Come funziona?',
            auting_connect_modal: {
                title: 'Come funziona Auting Connect',
                content: 'Auting Connect ti permette di accedere all\'auto senza incontrare l\'Owner tramite l\'App Auting.\nPrima di effettuare una prenotazione Auting Connect è obbligatorio scaricare sul tuo smartphone l\'App Auting.\nAssicurati che il Gps e i dati mobili siano attivati sul tuo smartphone.\nL\'apertura e la chiusura del viaggio e dell\'auto vengono effettuate tramite l\'App.\nLa posizione dell\'auto sarà visibile solo 30 minuti prima dell\'inizio del viaggio.\nRiceverai il PIN per aprire il veicolo via mail, con oggetto ‘PIN necessario per accedere all\'auto\'.\nQuando sarai vicino all\'auto potrai seguire la procedura indicata sull\'App ed aprire la portiera.\nTroverai le chiavi all\'interno dell\'auto.\nDurante il viaggio usa la chiave per aprire e chiudere l\'auto.\nA fine viaggio, riconsegna l\'auto entro 500 metri dal punto in cui l\'hai trovata.\nEffettua sull\'App la procedura di chiusura del viaggio e della portiera dell\'auto.',
                faq_link: 'FAQ',
                how_it_works_link: 'Come funziona',
                close: 'CHIUDI'
            },
            pro_user_modal: {
                title: 'Utente Professionale',
                content: '<strong>L\'utente Owner è definito "Professionale" quando fornisce per il viaggio una copertura assicurativa base di un proprio partner assicurativo, inclusa nel prezzo pagato online.</strong> Questa copertura assicurativa ha come base una copertura RCA e può avere anche altre coperture aggiuntive incluse (ad esempio, kasko, assistenza stradale, altro). <strong>Auting NON fornisce la copertura assicurativa del nostro partner Reale Mutua.</strong><br><br>Nel caso in cui l\'Owner sia un Utente Professionale, il presente contratto ha validità esclusivamente fino al check-in. Per il check-in, per il viaggio, per il check-out e per la gestione successiva al viaggio, fanno fede le condizioni contrattuali dell\'Utente Professionale.<br><br><strong>Quando avviene il checkin, l\'utente Professionale potrà richiedere al Driver di firmare accordi ulteriori a quelli di Auting e di rispettare ulteriori requisiti.</strong> <strong>Ad esempio può: richiedere un deposito cauzionale sulla carta di credito;</strong> offrire coperture assicurative opzionali e servizi extra; chiedere un sovrapprezzo se il Driver desidera la consegna in un luogo diverso da quello segnalato; avere politiche diverse su gestione multe; fornire auto diverse da quelle dell\'annuncio ma di stessa fascia economica.<br><br>Effettuando una prenotazione e successivamente il pagamento online per questo veicolo, il Driver accetta che l\'Owner possa richiedere ulteriori condizioni di contratto e servizi ad inizio e fine viaggio.',
                close: 'CHIUDI'
            },
            year: 'Anno',
            brand: 'Marca',
            model: 'Modello',
            type: 'Tipo',
            fuel: 'Alimentazione',
            gears: 'Cambio',
            doors_number: 'N. porte',
            unknown: 'Sconosciuto',
            reviews: 'recensioni',
            trips_completed: 'viaggi completati',
            vehicle_new_no_reviews: 'Questo veicolo è stato pubblicato di recente e non ha ancora recensioni.',
            be_first_to_review: 'Rescensisci per primo questa auto!',
            system_review: 'Recensione sistema',
            no_comment_provided: 'Nessun commento fornito',
            guidelines: 'Linee guida',
            faqs: 'FAQ',
            read_more: 'Leggi di più',
            dates: 'Date',
            change: 'Cambia',
            pickup_return: 'Ritiro e riconsegna',
            trip_saving: 'Risparmio viaggio',
            cancellation: 'Cancellazione',
            distance_included: 'Distanza inclusa',
            request_more: 'Richiedi di più',
            checking_availability: 'Verifica disponibilità...',
            continue_booking: 'Continua con la prenotazione',
            no_charge_note: 'Non riceverai alcun addebito in questa fase',
            vehicle_not_available_short: 'Veicolo non disponibile',
            vehicle_not_available_dates: 'Questo veicolo non è disponibile per le date selezionate.',
            days: 'giorni',
            discount: 'di sconto',
            additional_km: 'Km aggiuntivi',
            service_cost: 'Costo servizio',
            security_deposit: 'Deposito cauzionale',
            limited_liability: 'Responsabilità limitata',
            enter_promo_code: 'Inserisci codice promo',
            apply: 'Applica',
            coupon: 'Coupon',
            total: 'Totale',
            loading_car_details: 'Caricamento dettagli auto...',
            edit_booking_dates: 'Modifica date prenotazione',
            select_additional_km: 'Seleziona chilometri aggiuntivi',
            continue: 'Continua',
            not_available: 'Non disponibile',
            booking_summary: 'Riepilogo prenotazione',
            transmission: {
                manual: 'Manuale',
                automatic: 'Automatico'
            },
            modify_booking_dates: 'Modifica date prenotazione',
            select_additional_kilometers: 'Seleziona chilometri aggiuntivi',
            km_description: 'Scegli quanti chilometri aggiuntivi ti servono per il tuo viaggio:',
            no_charge_at_this_stage: 'Non riceverai alcun addebito in questa fase. Il pagamento sarà elaborato dopo l\'approvazione dell\'Owner.',
            be_first_reviewer: 'Rescensisci per primo questa auto!',
            fuel_types: {
                benzina: 'Benzina',
                diesel: 'Diesel',
                gpl: 'GPL',
                metano: 'Metano',
                elettrica: 'Elettrica',
                ibrida: 'Ibrida'
            },
            categories: {
                berlina: 'Berlina',
                city_car: 'Citycar',
                fuoristrada: 'Fuoristrada',
                minivan: 'Monovolume',
                station_wagon: 'Station Wagon',
                suv: 'SUV',
                crossover: 'Crossover',
                furgone: 'Furgone'
            },
            comforts_list: {
                animali: 'Animali',
                aria_condizionata: 'Aria condizionata',
                catene_da_neve: 'Catene da neve',
                fumatori: 'Fumatori',
                guida_disabili: 'Guida disabili',
                lettore_cd: 'Lettore CD',
                navigatore: 'Navigatore',
                permesso_ztl: 'Permesso ZTL',
                pneumatici_invernali: 'Pneumatici invernali',
                porta_bici: 'Porta bici',
                porta_pacchi: 'Porta pacchi',
                porta_sci: 'Porta sci',
                porta_usb: 'Porta USB',
                seggiolino_bambini: 'Seggiolino bambini',
                sensori_parcheggio: 'Sensori parcheggio',
                luci_xeno: 'Luci Xeno',
                cruise_control: 'Cruise Control',
                guida_disabili: 'Guida Disabili',
            },
            conditions_list: {
                animali: 'Animali NON ammessi',
                fumatori: 'NON si può fumare',
            },
            promo_box: {
                title: 'PROMOZIONE SPECIALE',
                description: 'FRANCHIGIA ZERO a soli 6€/gg in più!\nClicca continua per scegliere come proteggere il tuo viaggio.'
            },
            protection_by_pro_owner: 'Assicurazione fornita dall\'Owner Professionale',
            invalid_promo_code: 'Codice promo non valido',
            connect_claim: 'Apri questa auto tramite app. Non è necessaria alcuna interazione di persona.',
        },
        search: {
            page_title: 'Cerca l\'auto di cui hai bisogno',
            cars_available: 'auto disponibili',
            cars_found: 'auto trovate',
            searching_vehicles: 'Cercando veicoli...',
            search_error: 'Errore nella ricerca',
            loading_error: 'Errore nel caricamento dei veicoli',
            no_vehicles_found: 'Nessun veicolo trovato per i criteri di ricerca selezionati. Prova a modificare le date o i filtri, o a espandere la tua ricerca a luoghi vicini.',
            refresh_search: 'Aggiorna ricerca',
            sort_by: 'Ordina per',
            verified: 'Verificato',
            trips: 'viaggi',
            per_day: 'giorno',
            total: 'totale',
            why_convenient: 'Perché è conveniente?',
            no_reviews: 'Nessuna recensione',
            new_vehicle: 'Nuovo veicolo',
            update_search: 'Aggiorna la tua ricerca',
            seats: 'posti',
            included: 'inclusi',
            locate_on_map: 'Mostra sulla mappa',
            sorting: {
                relevance: 'Rilevanza',
                price: 'Prezzo',
                distance: 'Distanza'
            },
            transmission: {
                manual: 'Manuale',
                automatic: 'Automatico'
            },
            filters: {
                title: 'Filtri',
                type: 'Tipo',
                price_range: 'Fascia di prezzo',
                auting_connect: 'Auting Connect',
                super_owner: 'Super Owner',
                super_owner_only: 'Solo Super Owner',
                super_owner_desc: 'I Super Owner sono Owner professionali esperti nella condivisione delle loro auto su Auting. Offrono un servizio di alta qualità, hanno un\'ottima cura dei driver, e condividono sempre volentieri le loro auto.',
                all_owners: 'Tutti gli Owner',
                filter_by_car: 'Filtra per auto',
                any_brand: 'Qualsiasi marca',
                seats: 'Posti',
                doors: 'Porte',
                fuel: 'Alimentazione',
                gear: 'Cambio',
                categories: {
                    saloon: 'Berlina',
                    city_car: 'Citycar',
                    off_road: 'Fuoristrada',
                    minivan: 'Monovolume',
                    station_wagon: 'Station Wagon',
                    suv: 'SUV'
                },
                connect: {
                    any_desc: 'Sia con che senza Auting Connect.',
                    with: 'Con Auting Connect',
                    with_desc: 'Apri le porte tramite app. Non è necessaria alcuna interazione di persona.',
                    without: 'Senza Auting Connect',
                    without_desc: 'È necessaria un\'interazione di persona quando si inizia/termina il viaggio.'
                },
                fuel_types: {
                    gasoline: 'Benzina',
                    diesel: 'Diesel',
                    lpg: 'GPL',
                    methane: 'Metano',
                    electric: 'Elettrica',
                    hybrid: 'Ibrida'
                },
                gear_types: {
                    manual: 'Manuale',
                    automatic: 'Automatico'
                }
            },
            price_info: {
                title: 'Perché è conveniente?',
                premium_includes: 'Il prezzo PREMIUM include:',
                remember: 'Ricorda',
                competitor_comparison: 'quando valuti il prezzo, considera che i nostri concorrenti richiedono un deposito cauzionale e opzioni di responsabilità fino a €3500.',
                benefits: {
                    free_cancellation: 'Cancellazione gratuita',
                    reduced_liability: 'Responsabilità ridotta per danni e furto',
                    roadside_assistance: 'Assistenza stradale 24/7',
                    no_deposit: '0€ deposito cauzionale'
                }
            },
            premium_box: {
                title: 'Il prezzo PREMIUM include:',
                benefits: {
                    free_cancellation: 'Cancellazione gratuita',
                    reduced_liability: 'FRANCHIGIA ZERO a soli 6€/gg in più!',
                    roadside_assistance: 'Assistenza stradale 24/7',
                    no_deposit: 'Nessun deposito cauzionale'
                }
            }
        },
        alternatives: {
            page_title: 'Questi Owner rispondono velocemente',
            page_subtitle: 'Selezionate tra gli Owner con il più alto tasso di risposta — e che quasi sempre dicono sì. Non aspettare: altri driver potrebbero prenotarle prima di te.',
            banner_title: '{n} auto selezionate per te',
            banner_subtitle: 'Abbiamo selezionato queste auto dopo aver visto le tue richieste di prenotazione.\r\nSperiamo che una di queste sia perfetta per te!\r\nOgni giorno vengono inserite auto nuove, quindi torna a controllare se non trovi subito quella giusta.',
            see_all_results: 'Cerca altre auto',
        },
        protection: {
            page_title: 'Protezione viaggio',
            auting_protection: 'Solo con Auting',
            title: 'Approfitta a pieno, scegli la copertura furto/danni...',
            features: {
                title: 'Già incluso in TUTTE le opzioni:',
                assistance: {
                    title: 'Assistenza',
                    desc: 'Assistenza stradale 24/7'
                },
                liability: {
                    title: 'Opzioni di responsabilità',
                    desc: 'Protetto per danni, collisione, furto, vandalismo, protezione vetri'
                },
                deposit: {
                    title: 'Deposito cauzionale',
                    desc: 'Nessun deposito cauzionale'
                }
            },
            details_prefix: 'Per i dettagli delle opzioni di limitazione delle responsabilità,',
            learn_more: 'leggi qui',
            choose_protection: '... tra queste tre opzioni',
            promo: 'Promo',
            max_out_of_pocket: 'in caso di danni o furto',
            no_out_of_pocket: 'Nessun costo in caso di danni o furto',
            physical_damage: 'Danni, collisione, furto, vandalismo, protezione vetri',
            no_deposit: 'Nessun deposito cauzionale',
            free: 'Gratuito',
            summary_title: 'Potrai procedere con il pagamento dopo che l\'Owner avrà accettato la prenotazione',
            days: 'giorni',
            from: 'Partenza',
            to: 'Rientro',
            additional_km: 'Km aggiuntivi',
            service_cost: 'Costo servizio',
            security_deposit: 'Deposito cauzionale',
            enter_promo_code: 'Inserisci codice promo',
            apply: 'Applica',
            protection: 'Protezione',
            coupon: 'Coupon',
            total: 'Totale',
            pricing_error: 'Errore aggiornamento prezzi',
            next: 'Avanti',
            booking_summary: 'Riepilogo prenotazione'
        },
        booking_summary: {
            page_title: 'Riepilogo prenotazione',
            title: 'Riepilogo Prenotazione',
            subtitle: 'Controlla i dettagli della prenotazione prima di confermare',
            trip_info: 'Info Viaggio',
            dates: 'Date',
            pickup_return: 'Ritiro e Riconsegna',
            trip_saving: 'Risparmio Viaggio',
            cancellation: 'Cancellazione',
            distance_included: 'Distanza inclusa',
            protection: 'Protezione',
            change: 'Cambia',
            request_more: 'Richiedi di più',
            confirm_booking: 'Conferma',
            free_cancellation: 'Cancellazione gratuita fino a 24h prima',
            trip_discount: 'Sconto 3 giorni',
            total: 'Totale',
            days: 'giorni',
            not_specified: 'Non specificato',
            location_not_available: 'Posizione non disponibile',
            km_included: 'km inclusi',
            additional: 'aggiuntivi',
            booking_summary: 'Riepilogo prenotazione',
            additional_km: 'Km aggiuntivi',
            service_cost: 'Costo servizio',
            security_deposit: 'Deposito cauzionale',
            enter_promo_code: 'Inserisci codice promo',
            applied: 'Applicato',
            apply: 'Applica',
            promo: 'Promo',
            booking_note: 'Non riceverai alcun addebito in questa fase. Il pagamento sarà possibile solo dopo l\'approvazione dell\'Owner.',
            edit_dates: 'Modifica date prenotazione',
            message_to_owner: 'Messaggio al Proprietario',
            your_message: 'Il tuo messaggio all\'Owner',
            message_placeholder: 'Scrivi un messaggio all\'Owner...',
            cancel: 'Annulla',
            sending: 'Invio...',
            send_request: 'Invia Richiesta',
            select_additional_km: 'Seleziona Chilometri Aggiuntivi',
            default_message: 'Ciao! Sono interessato a prenotare la tua {vehicleName} dal {startDate} al {endDate}. Non vedo l\'ora di sentirti!',
            auth_required: 'Devi essere autenticato per completare la prenotazione. Vuoi accedere ora?',
            message_required: 'Scrivi un messaggio all\'Owner',
            data_restored: 'I tuoi dati di prenotazione sono stati ripristinati. Puoi continuare con la prenotazione.',
            // authentication_required: 'You must be authenticated to complete the reservation. Do you want to sign in now?'
            authentication_required: 'Devi essere autenticato per completare la prenotazione. Vuoi accedere ora?',
            login_now: 'Accedi'
        },
        booking_confirmation: {
            page_title: 'Richiesta inviata all\'Owner',
            title: 'Richiesta inviata all\'Owner',
            instruction_1: '1. L\'Owner di solito risponde in poche ore.',
            instruction_2: '2. Dopo che l\'Owner avrà approvato la richiesta, potrai procedere con il pagamento.',
            trip_info: 'Informazioni del Viaggio',
            vehicle_name: 'Nome del Veicolo',
            location_not_available: 'Posizione non disponibile',
            dates: 'Date',
            not_specified: 'Non specificato',
            pickup_return: 'Ritiro e Riconsegna',
            trip_saving: 'Risparmio del Viaggio',
            day_booking: 'giorni di prenotazione',
            cancellation: 'Cancellazione',
            free_cancellation_until: 'Cancellazione gratuita fino a 24h prima della partenza',
            distance_included: 'Distanza inclusa',
            km_included: 'km inclusi',
            additional: 'aggiuntivi',
            protection: 'Protezione',
            homepage: 'Homepage',
            invalid_date: 'Data non valida',
            accepted_title: 'Prenotazione accettata!',
            accepted_instruction: 'La tua prenotazione è stata accettata automaticamente. Ora puoi procedere con il pagamento.',
            owner_message_label: 'Messaggio del proprietario',
            proceed_to_payment: 'Procedi con il pagamento',
            suggestions: {
                title: 'Auto disponibili per le stesse date',
                subtitle: 'Abbiamo selezionato <strong>apposta per te</strong> queste auto disponibili per le stesse date, appartengono ad Owner che rispondono rapidamente.<br/><br/>Ti consigliamo di inviare una richiesta, poi decidi tu se finalizzarla o meno, altri Driver potrebbero prenotarle prima di te.',
                see_all: 'Oppure puoi fare una nuova ricerca',
            },
            protection: {
                label: 'Protezione',
                minimum_750: 'Minimum 750',
                standard_500: 'Standard 500',
                smart_250: 'Smart 250',
                franchigia_0: 'Franchigia Zero'
            }
        }
    },
}